import React, { useState, useEffect } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ImageComponent from 'atoms/Image';

const { SingleArrowBlackExpand, SingleArrowBlack } = IMAGE_PATH;
const { TIME_NOT_AVAILABLE } = TRANSLATE_MAPPING_KEY;

/**
 *  Accordion Component
 * @param {*} props - Object
 */

const CustomDropdown = props => {
  const {
    cssClass,
    dropdownTitle,
    setSelectedItem,
    selectedItem,
    options,
    dropdownId,
    changeTimeObj = {},
    changeDateObj = {},
    dateTimeArr = [],
    placeholderText,
    disableOptions = false,
    enableOrderCapacityManagement = false,
    shouldDisplayDropdownError = false,
    errorMessage = '',
    dataTestid = '',
    elementUniqueLocator,
  } = props;
  const selectedItemValue = selectedItem?.value || placeholderText;
  const [isOpen, setIsOpen] = useState(false);
  const { setSelectedTime = null, setErrorObj = {} } = changeTimeObj;
  const { setSelectedDate = null, dispositionType = '' } = changeDateObj;
  /* called when user clicks on dropdown option */
  const onSelect = (e, item) => {
    e?.preventDefault();
    e?.stopPropagation();
    setIsOpen(false);

    if (dropdownId === 'time-id') {
      // Consider order capacity availability before selecting the time
      if (!enableOrderCapacityManagement || (enableOrderCapacityManagement && item?.isOrderCapacityAvailable)) {
        setSelectedItem(item, setSelectedTime, setErrorObj);
      }
    } else {
      setSelectedItem(
        item,
        dateTimeArr,
        setSelectedDate,
        setSelectedTime,
        setErrorObj,
        dispositionType,
        changeDateObj,
        enableOrderCapacityManagement,
      );
    }
  };
  /* called as didmount & to register click eventlistener */
  useEffect(() => {
    const closeDropdown = e => {
      e?.stopPropagation();
      if (!e?.target?.matches(`#${dropdownId}`) && !e?.target?.closest(`#${dropdownId}`)) {
        setIsOpen(false);
      }
    };
    window.addEventListener('click', closeDropdown);
    return () => {
      window.removeEventListener('click', closeDropdown);
    };
  }, [dropdownId]);

  return (
    <div className={`custom-dropdown ${cssClass} ${shouldDisplayDropdownError ? 'custom-dropdown-error' : ''}`}>
      {dropdownTitle && (
        <div className='dropdown-title' aria-level='1' role='heading' tabIndex='0'>
          {dropdownTitle}
        </div>
      )}
      <div
        id={dropdownId}
        className='dropdown-value'
        data-testid={elementUniqueLocator ? dataTestid : 'dropdown-value-id'}
        role='listbox'
        tabIndex='0'
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className='selected-value'>{selectedItemValue}</div>
        {!disableOptions && (
          <img src={isOpen ? SingleArrowBlackExpand : SingleArrowBlack} alt=' ' className='downarrow-imgs' />
        )}
      </div>
      {!disableOptions && isOpen && (
        <div className='options-container'>
          <ul>
            {options?.map(item => {
              let itemValue = item?.value;
              let itemClassName = item?.disabled || item?.storeClosed ? 'disabledOption' : '';
              
              // Disable time dropdown when orderCapacity is activated and the item has no capacity
              if (dropdownId === 'time-id' && enableOrderCapacityManagement && !item?.isOrderCapacityAvailable) {
                itemValue += ` ${translateWithI18Next(TIME_NOT_AVAILABLE)}`;
                itemClassName += ' unavailableOption';
              }
              return (
                <li
                  key={item?.key}
                  tabIndex='0'
                  onClick={e => onSelect(e, item)}
                  className={itemClassName}
                  data-testid='option-id'
                >
                  {itemValue}
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {shouldDisplayDropdownError && (
        <div className='dropdown-error'>
          <ImageComponent srcFile={IMAGE_PATH.Error} className='store-cannot-deliver-icon' />
          <div className='dropdown-error-message'>{errorMessage}</div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
